import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { getTenantConfig } from '@/api/user'
import useTenantConfig from '@/store/tenant-config-store'

export const Route = createFileRoute('/_auth/automation')({
  component: Index,
  beforeLoad: async () => {
    const store = useTenantConfig.getState()

    if (!store.tenantConfig) {
      const response = await getTenantConfig()
      if (response?.data) {
        store.setTenantConfig(response.data)
      }
    }

    const tenantConfig = useTenantConfig.getState().tenantConfig

    if (!tenantConfig || tenantConfig?.workflow !== 'enabled') {
      throw redirect({
        to: '/',
      })
    }
  },
})

function Index() {
  return <Outlet />
}
